import React, { useEffect, useState } from 'react';

import Button from 'ui/Button';
import ValidationMessage from 'features/Betslip/ValidationMessage';

import { couponValidation } from 'utils/Big9BetslipHelper';
import { ConnectedEditCoupon as EditCoupon } from './EditCoupon';
import {
    convertSelectionsToBig9Format,
    findWildcardEventNumber,
    getBig9SelectionsSplitArray,
} from '../state/helpers';
import BuyCoupon from './BuyCoupon';

import checkmark from 'images/icons/big9/checkmark.svg';

const CouponFooter = ({
    coupon,
    poolHash,
    pool,
    finishedCoupon = false,
    isPoolOwner = false,
    refetchPoolDetails,
}) => {
    const [editing, setEditing] = useState(false);

    const selectionsToValidate = getBig9SelectionsSplitArray(
        convertSelectionsToBig9Format(coupon.selections)
    );

    const wildcardEventNumber = findWildcardEventNumber(coupon.selections);

    const { status: validCoupon, message } = couponValidation(
        selectionsToValidate,
        wildcardEventNumber,
        coupon.couponAmount
    );

    const getSkClass = () => {
        if (window.location.pathname.split('/')[3] === 'pool') {
            return 'skEmpty';
        } else {
            return '';
        }
    };

    return (
        <>
            {isPoolOwner && (
                <>
                    <EditCoupon
                        shown={editing}
                        closeEditor={() => setEditing(false)}
                        coupon={coupon}
                        poolHash={poolHash}
                        originalWildcardEventNumber={wildcardEventNumber}
                        refetchPoolDetails={refetchPoolDetails}
                    />

                    {!validCoupon &&
                        !finishedCoupon && (
                            <ValidationMessage
                                message={message}
                                wrapperStyles={{
                                    margin: '10px 0',
                                    width: '100%',
                                }}
                                className={`fade-in ${getSkClass()}`}
                            />
                        )}
                </>
            )}

            {!finishedCoupon ? (
                coupon.betWasPlaced ? (
                    <Button
                        green
                        margin="10px 0 0 0"
                        width="100%"
                        className="fade-in"
                    >
                        Kupon placeret{' '}
                        <span className="checkmark-icon">
                            <img src={checkmark} />
                        </span>
                    </Button>
                ) : (
                    isPoolOwner && (
                        <div className="flex sk-">
                            <Button
                                className="flex-grow"
                                onClick={() => setEditing(true)}
                                margin={'10px 10px 10px 0'}
                                padding={'15px 10px'}
                                style={{ maxWidth: 'calc(50% - 10px)' }}
                            >
                                Rediger Big 9 kupon
                            </Button>

                            <BuyCoupon
                                coupon={coupon}
                                poolHash={poolHash}
                                validCoupon={validCoupon}
                                pool={pool}
                                refetchPoolDetails={refetchPoolDetails}
                            />
                        </div>
                    )
                )
            ) : null}
        </>
    );
};

export default CouponFooter;
